<template>
  <div class="col q-mini-drawer-hide">
    <q-list separator class="tree tree--role tree--full-height">
      <template v-for="role in roles" :key="role.id">
        <item-link class="row items-center q-pl-md"
                   :active="current === role.id"
                   :href="$route('user.role.edit', {rol: role.id})">
          {{ role.name }}
          <q-space />
          <common-chip v-if="role.is_default_role" label="Standaard rol" filled small/>
        </item-link>
      </template>
    </q-list>
  </div>
</template>

<script>
export default {
  props: {
    roles: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    current () {
      const id = this.$route().params.rol
      if (!id) return null
      return parseInt(id)
    },
  },
}
</script>
